export const ApprovalTableTypes = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  EXPIRED: 'expired',
} as const
export type ApprovalTableType = (typeof ApprovalTableTypes)[keyof typeof ApprovalTableTypes]
